/**
 * Laughlin Highlands Farm Box Builder safeguards.
 *
 * Replaces an empty configurable box's misleading $0 total with guidance.
 * Boxi owns item-count enforcement and the Add to cart button state. Builder
 * cards and prices are rendered directly by Liquid in card-product.liquid.
 * This file is intentionally separate from theme.liquid so it can be reviewed
 * and restored during theme updates.
 */
(() => {
  const builderPath = '/apps/boxi/box-builder/3385';

  const initBuilderGuard = () => {
    if (window.location.pathname !== builderPath) return;

    const style = document.createElement('style');
    style.textContent = `
      [data-lhf-box-total-empty="true"] {
        font-weight: 600;
      }
    `;
    document.head.appendChild(style);

    let updateQueued = false;

    const getTotals = () => {
      const classMatches = Array.from(document.querySelectorAll('[class*="_totalAmount_"]'));
      const semanticMatches = Array.from(document.querySelectorAll('main div')).filter((element) => {
        const label = element.querySelector(':scope > span:first-child');
        return label && label.textContent.trim().toLowerCase() === 'total:';
      });

      return Array.from(new Set([...classMatches, ...semanticMatches]));
    };

    const updateBuilderState = () => {
      updateQueued = false;

      const totals = getTotals();
      const positiveTotal = totals
        .map((element) => element.textContent.match(/Total:\s*(\$[\d,.]+)/i))
        .find((match) => match && Number(match[1].replace(/[$,]/g, '')) > 0);
      const hasSelection = Boolean(positiveTotal);

      totals.forEach((total) => {
        const amount = total.querySelector('span:last-child') || total;
        const desiredText = hasSelection
          ? positiveTotal[1]
          : 'Choose 10 items to build your box';

        if (amount.textContent.trim() !== desiredText) amount.textContent = desiredText;
        total.dataset.lhfBoxTotalEmpty = String(!hasSelection);
      });
    };

    const queueBuilderUpdate = () => {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateBuilderState);
    };

    new MutationObserver(queueBuilderUpdate).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    queueBuilderUpdate();
  };

  const init = () => {
    initBuilderGuard();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
